<script setup>
const props = defineProps(["cta", "white"]);

const link = computed(() => {
  return props.cta.type === "email"
    ? `mailto:${props.cta.link}`
    : props.cta.type === "phone"
    ? `tel:${props.cta.link}`
    : props.cta.link;
});
</script>

<template>
  <div class="cta">
    <a target="_blank" rel="noopener noreferrer" :href="link">
      <p>
        {{ cta.type === "email" || cta.type === "phone" ? cta.link : cta.type }}
      </p>
    </a>
    <img src="/images/arrow.svg" :class="{ inverted: white }" />
  </div>
</template>

<style>
.cta {
  display: flex;
  justify-content: end;
  align-items: center;
  &:first-of-type {
    padding-left: 48px;
  }
  p {
    margin: 0;
    font-weight: 600;
    text-transform: uppercase;
  }
  a {
    text-decoration: none;
    display: flex;
    align-items: center;
  }
  img {
    width: 16px !important;
    padding-left: 12px;
    transition: transform 0.3s ease-out;
    @media (max-width: 767px) {
      width: 10px;
    }
    @media (max-width: 1201px) {
      width: 12px;
    }
  }
  &:hover img {
    transform: translateX(8px);
  }
  .inverted {
    filter: invert();
  }
}
</style>
